export interface Modal {
  id: number;
  component: any;
  props?: Record<string, unknown>;
}

export default function useModal() {
  const modals = useState<Modal[]>("modals", () => []);

  let id = 0;

  function openModal(component: any, props: Modal["props"] = {}) {
    modals.value.push({ id: ++id, component, props });
  }

  function closeTopModal() {
    if (modals.value.length > 0) {
      modals.value.pop();
    }
  }

  return {
    modals: readonly(modals),
    openModal,
    closeTopModal,
  };
}
